import { get} from "./base";

export function getMenus(onSuccess, onError) {
    get(
      "/api/applications/menus/query",
      {},
      {},
      (res) => {
        onSuccess(res.data);
      },
      (error) => {
        console.error(error);
        onError(error);
      }
    );
  }